export default "__VITE_PUBLIC_ASSET__e1cc7945__"